export const contactManagementVersion = '14.0.4';
